import React, { useEffect, useState } from "react";
import { EngagementNewTable } from "modules/engagement_report/engagement_summary/EngagementNewTable";
import {
  getFormattedStartDate,
  getFormattedEndDate,
  formatDate,
  summaryEndDate,
  summaryEndOne,
  summaryStartOne,
} from "functionCall";
import useEngSummaryStore from "modules/engagement_report/engagement_summary/store";
import SummaryModal from "modules/engagement_report/engagement_summary/SummaryModal";
import PaginationDiv from "modules/pagination/PaginationDiv";
import CardDiv from "modules/common/card-div/CardDiv";

function EngagementSummary() {
  const {
    summaryData,
    summaryUser,
    isLoading,
    error,
    fetchSummaryData,
    fetchUserData,
  } = useEngSummaryStore();
  const [startDate, setStartDate] = useState(getFormattedStartDate());
  const [endDate, setEndDate] = useState(getFormattedEndDate(0));
  const [inputStartDate, setInputStartDate] = useState(formatDate(startDate));
  const [inputEndDate, setInputEndDate] = useState(summaryEndDate(endDate));
  const [inputStartDateOne, setInputStartDateOne] = useState(
    summaryStartOne(startDate)
  );
  const [inputEndDateOne, setInputEndDateOne] = useState(
    summaryEndOne(`${endDate}T23:59:59+0530`)
  );
  const [startFilterDate, setStartFilterDate] = useState("");
  const [endFilterDate, setEndFilterDate] = useState("");
  const [agent, setAgent] = useState("");
  const [callType, setCallType] = useState("");
  const [agentId, setAgentId] = useState("");
  const [callId, setCallId] = useState("");
  const [page, newPage] = useState(1);
  const [filterData, setFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);

  useEffect(() => {
    fetchUserData();
  }, []);

  const numOfSubarrays = Math.max(
    Math.ceil((summaryData?.length || 0) / 10),
    0
  );

  const arrayOfArrays = summaryData
    ? Array.from({ length: numOfSubarrays }, (_, i) => {
        const start = i * 10;
        const end = start + 10;
        return summaryData.slice(start, end);
      })
    : [];

  useEffect(() => {
    setFilter(summaryData?.slice(0, 10));
  }, [summaryData]);

  useEffect(() => {
    setPageCount(Math.max(Math.ceil((summaryData?.length || 0) / 10), 1));
  }, [summaryData]);

  useEffect(() => {
    setFilter(arrayOfArrays[page - 1]);
  }, [page]);

  useEffect(() => {
    if (startFilterDate && endFilterDate) {
      let filterStartDate = formatDate(startFilterDate);
      let filterEndDate = summaryEndDate(endFilterDate);
      let filterStartDateOne = summaryStartOne(startFilterDate);
      let filterEndDateOne = summaryEndOne(`${endFilterDate}T23:59:59+0530`);

      if (agentId.length === 0 && callId.length === 0) {
        fetchSummaryData(
          filterStartDate,
          filterEndDate,
          filterStartDateOne,
          filterEndDateOne
        );
      } else if (agentId.length !== 0 && callId.length === 0) {
        let queryParams = "&repId=" + agentId;
        fetchSummaryData(
          filterStartDate,
          filterEndDate,
          filterStartDateOne,
          filterEndDateOne,
          queryParams
        );
      } else if (agentId.length === 0 && callId.length !== 0) {
        let queryParams = "&callType=" + callId;
        fetchSummaryData(
          filterStartDate,
          filterEndDate,
          filterStartDateOne,
          filterEndDateOne,
          queryParams
        );
      } else if (agentId.length !== 0 && callId.length !== 0) {
        let queryParams = "&repId=" + agentId + "&callType=" + callId;
        fetchSummaryData(
          filterStartDate,
          filterEndDate,
          filterStartDateOne,
          filterEndDateOne,
          queryParams
        );
      }
    } else {
      let queryParams = "";
      if (!startFilterDate && !endFilterDate) {
        queryParams = "&repId=" + agentId;
        fetchSummaryData(
          inputStartDate,
          inputEndDate,
          inputStartDateOne,
          inputEndDateOne,
          queryParams
        );
        fetchUserData();
      } else if (agentId.length !== 0 && callId.length === 0) {
        queryParams = "&repId=" + agentId;
        fetchSummaryData(
          inputStartDate,
          inputEndDate,
          inputStartDateOne,
          inputEndDateOne,
          queryParams
        );
      } else if (agentId.length === 0 && callId.length !== 0) {
        queryParams = "&callType=" + callId;
        fetchSummaryData(
          inputStartDate,
          inputEndDate,
          inputStartDateOne,
          inputEndDateOne,
          queryParams
        );
      } else if (agentId.length !== 0 && callId.length !== 0) {
        queryParams = "&repId=" + agentId + "&callType=" + callId;
        fetchSummaryData(
          inputStartDate,
          inputEndDate,
          inputStartDateOne,
          inputEndDateOne,
          queryParams
        );
      }
    }
  }, [
    agentId,
    callId,
    inputStartDate,
    inputEndDate,
    startFilterDate,
    endFilterDate,
    agent,
    callType,
  ]);


  return (
    <CardDiv
      title={
        <div className="float-end">
          <SummaryModal
            summaryUser={summaryUser}
            setStartFilterDate={setStartFilterDate}
            setEndFilterDate={setEndFilterDate}
            setAgent={setAgent}
            setCallType={setCallType}
            agent={agent}
            callType={callType}
            setAgentId={setAgentId}
            setCallId={setCallId}
          />
        </div>
      }
      component={
        <>
          <div >
            <EngagementNewTable summaryData={filterData} />
          </div>
          <PaginationDiv
            newPage={newPage}
            paginationData={{ pageCount: Number(pageCount) || 1, page:page }}
            
          />
        </>
      }
    />
  );
}

export default EngagementSummary;
